import { Anchor } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './SkipLink.module.css';

/**
 * Visually hidden skip link shown on keyboard focus.
 * @param {object} props
 * @param {string} [props.targetId='main-content']
 */
export function SkipLink({ targetId = 'main-content' }) {
  const { t } = useTranslation('common');

  return (
    <Anchor href={`#${targetId}`} className={classes.skipLink}>
      {t('common.skipToContent')}
    </Anchor>
  );
}
